<template>
  <InputComponent v-bind="$attrs" v-on="$listeners">
    <template v-if="copyToClipboard" #right>
      <ButtonComponent :label="$t('copy')" :success-label="$t('copied')" :icon="['fal', 'copy']" :promise="clipPromise"
        @click="copy" />
    </template>
  </InputComponent>
</template>


<script>
 import { InputComponent } from 'vue-elder-input'
import { CopyToClipboard } from '../utils'

export default {
  props: {
    copyToClipboard: Boolean,
  },
  data() {
    return {
      clipPromise: null,
    }
  },
  methods: {
    copy() {
      return (this.clipPromise = Promise.resolve(CopyToClipboard(this.$attrs.value)))
    },
  },
  components: {
    InputComponent
  }
}
</script>
